import './flexPeriod.css';

import { genericTooltip } from '../../genericTooltip/genericTooltip';

export const FlexPeriodView = Backbone.View.extend({
  initialize(context) {
    this.searchView = context;
    this.setElement(context.$el);
    this.temporaryModel = context.temporaryModel;
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.$flexField = $('.js-search-flexPeriod');
    this.periodLabel = '';

    this.months = [];
    this.holidays = [];
    this.flexSelection = {month: '', holiday: '', zone: ''};

    this.initListener();
  },
  getDatas() {
    $.when(
      this.getMonths()
    ).done(() => {
      $.when(
        this.getHolidays()
      ).done(() => {
        //-- Display flex Period
        this.getSelection();
        this.render();

        //-- Handle duration and availabity
        dispatcher.trigger('duration:render');
        dispatcher.trigger('duration:updateAvailability');

        //-- Upate month availability when no strict dates
        const arrivalDate = this.temporaryModel.get('arrivalDate');
        if (arrivalDate === null || arrivalDate === '' || this.temporaryModel.get('duration')) {
          this.updateMonths();
        }

        //-- Initiate events
        this.initEvents();
        this.updateEngineField();
      });
    });
  },
  // Get months list from holiday api
  getMonths() {
    const deferred = $.Deferred();
    genericAjaxCall({
      ajaxUrl: SEARCH_SCRIPTS.URL_API_HOLIDAY + '/month/list',
      successCallback: callback => {
        this.months = callback.data;
        deferred.resolve();
      },
      abortable: true,
      type: 'GET',
      dataType: 'json'
    });
    return deferred.promise();
  },
  // Get holidays list from holiday api
  getHolidays() {
    const deferred = $.Deferred();
    genericAjaxCall({
      ajaxUrl: SEARCH_SCRIPTS.URL_API_HOLIDAY + '/holidays/' + GLOBAL_SCRIPTS.MARKET_CODE.toUpperCase() + '-' + GLOBAL_SCRIPTS.LANGUAGE_CODE.toUpperCase(),
      successCallback: callback => {
        this.holidays = callback.data.holidays;
        deferred.resolve();
      },
      abortable: true,
      type: 'GET',
      dataType: 'json'
    });
    return deferred.promise();
  },
  getSelection() {
    const flexPeriod = this.temporaryModel.get('isFlexPeriod');
    const flexZone = this.temporaryModel.get('flexZone');

    if (flexPeriod) {
      const dateStart = this.temporaryModel.get('arrivalDate');
      const dateEnd = this.temporaryModel.get('departureDate');
      let idxSelected = this.months.findIndex(month => month.start === dateStart && month.end === dateEnd);

      if (idxSelected !== -1) {
        this.flexSelection.month = 'm-' + this.months[idxSelected].code;
      } else {
        $.each(this.holidays, (idxHoliday, holiday) => {
          if (holiday.start === dateStart && holiday.end === dateEnd) {
            this.flexSelection.holiday = 'h-' + holiday.code;
          }

          if (flexZone) {
            $.each(holiday.zones, (key, zone) => {
              if (zone.start === dateStart && zone.end === dateEnd && flexZone === ('z-' + zone.id)) {
                this.flexSelection.zone = 'z-' + zone.id;
                this.flexSelection.holiday = 'h-' + holiday.code;
              }
            });
          }
        });
      }
    }
  },
  initListener() {
    this.stopListening(dispatcher, 'facette:flexPeriod:getDatas');
    this.listenTo(dispatcher, 'facette:flexPeriod:getDatas', this.getDatas);

    this.stopListening(dispatcher, 'facette:flexPeriod:clean');
    this.listenTo(dispatcher, 'facette:flexPeriod:clean', this.cleanFlexPeriod);

    this.stopListening(dispatcher, 'facette:flexPeriod:cleanFixDates');
    this.listenTo(dispatcher, 'facette:flexPeriod:cleanFixDates', this.cleanFixDates);

    this.stopListening(dispatcher, 'facette:flexPeriod:updateEngineField');
    this.listenTo(dispatcher, 'facette:flexPeriod:updateEngineField', this.updateEngineField);

    this.stopListening(dispatcher, 'facette:flexPeriod:updateSearchToggler');
    this.listenTo(dispatcher, 'facette:flexPeriod:updateSearchToggler', this.updateSearchToggler);

    this.stopListening(dispatcher, 'facette:flexPeriod:updateMonths');
    this.listenTo(dispatcher, 'facette:flexPeriod:updateMonths', this.updateMonths);
  },
  initEvents() {
    const $document = $(document);

    $document.on('click', '.js-dateFlexType', (e) => {
      e.preventDefault();
      this.switchDateType(e);
    });

    $document.on('click', '.js-periodFlexType', (e) => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);

      $('.flexPeriod').toggleClass('isHolidays', $currentTarget.hasClass('flexHolidays'));

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Flex calendar',
        gaLabel: $currentTarget.hasClass('flexHolidays') ? 'School holidays' : 'Month',
        event: 'clickEvent'
      });
    });

    $document.on('click', '.js-search-flexPeriod', (e) => {
      e.preventDefault();
      $('.js-search-date_begin').click();
      if (!DEVICE.isMobile) {
        this.$flexField.addClass('opened');
        dispatcher.trigger('slider:refresh', '.js-flexZoneSlider');
      }
    });

    $document.on('click', '.js-flexPeriod-validate', (e) => {
      e.preventDefault();
      if (DEVICE.isMobile) {
        $('.pika-header-close.js-pikaClose').click();

        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'flex_calendar',
          gaLabel: 'validate',
          event: 'clickEvent'
        });
      }
    });

    this.initSetPeriodEvent();
  },
  initSetPeriodEvent() {
    const $document = $(document);

    const updateSliderCenteredClass = () => {
      if (!DEVICE.isMobile) {
        if (document.querySelector('.js-flexZoneSlider').swiper.slides.length < 5) {
          document.querySelector('.js-flexZoneSlider .swiper-wrapper').classList.add('centered');
          document.querySelector('.js-flexZoneSlider .swiper-button-next').style.display = 'none';
          document.querySelector('.js-flexZoneSlider .swiper-button-prev').style.display = 'none';
        }
      }
    };

    $document.off('click.flexPeriod', '.js-selectPeriod');
    $document.on('click.flexPeriod', '.js-selectPeriod', (e) => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      this.setPeriod($currentTarget.attr('id'));
      updateSliderCenteredClass();
    });

    // Init flex zone slider & slideTo active index
    if (!DEVICE.isMobile) {
      SwiperComponents.initSlider('.js-flexZoneSlider', {
        slidesPerView: 5,
        slidesPerGroup: 5
      });

      const $swiperInstance = document.querySelector('.js-flexZoneSlider').swiper;
      $swiperInstance.update();
      $swiperInstance.slideTo($('.js-flexZoneSlider a.swiper-slide-active').index());
      updateSliderCenteredClass();
    }
  },
  // Switch to flex period or show disable tooltip if multicottage
  switchDateType(e) {
    const $currentTarget = $(e.currentTarget);
    if ($currentTarget.hasClass('dateFlex') && parseInt($('#js-searchEngine-cottageNumber').val()) === 2 ) {
      const $flexToggler = $('.js-dateFlexType.dateFlex');
      if (!$flexToggler.find('.genericTooltip').length) {
        genericTooltip.create($flexToggler, {
          id: 'mcDisableFlexPeriod',
          text: SEARCH_SCRIPTS.WORDING_SEARCH.mcDisableFlexPeriod,
          open: true
        });
      } else {
        genericTooltip.open('mcDisableFlexPeriod');
      }
      $(e.currentTarget).addClass('disable');
    } else {
      $('.calendarBlock').toggleClass('isFlex', $currentTarget.hasClass('dateFlex'));
    }

    Tracking.dataLayerPush({
      clickCode: '',
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'Flex calendar',
      gaLabel: $currentTarget.hasClass('dateFlex') ? 'Flexible period' : 'Exact dates',
      event: 'clickEvent'
    });
  },
  setPeriod(periodId) {
    const $period = $('#' + periodId);
    const isUnselect = $period.hasClass('active');

    const periodType = $period.parents('.js-flexMonths').length ? 'month' : $period.parents('.js-flexHolidays').length ? 'holiday' : 'zone';
    $((periodType === 'zone' ? '.js-flexZones ' :'') +'.js-selectPeriod').removeClass('active');

    if(!isUnselect) {
      $period.addClass('active');
      const dateStart = $period.data('start');
      const dateEnd = $period.data('end');
      const flexPeriodDatas = {};

      if (periodType === 'month') {
        this.flexSelection = {month: periodId, holiday: '', zone: ''};
        flexPeriodDatas.month = periodId;
      } else {
        if (periodType === 'holiday') {
          this.flexSelection = {month: '', holiday: periodId, zone: ''};
          flexPeriodDatas.holiday = periodId;
        }
        if (periodType === 'zone') {
          this.flexSelection.zone = periodId;
          flexPeriodDatas.holiday = this.flexSelection.holiday;
          flexPeriodDatas.zone = periodId;
        }
      }

      //-- nights used by product history
      const modelDatas = {
        isFlexPeriod: true,
        flexZone: this.flexSelection.zone,
        arrivalDate: dateStart,
        departureDate: dateEnd,
        nights: genericDate.diff(new Date(dateStart), new Date(dateEnd))
      };

      this.setDatas(modelDatas);
      this.cleanFixDates();

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'flex_calendar-step 2',
        gaLabel: $period.data('label'),
        event: 'clickEvent'
      });

    } else {
      if (periodType === 'zone') {
        this.flexSelection.zone = '';
      } else {
        this.flexSelection = {month: '', holiday: '', zone: ''};
      }

      const modelDatas = {
        isFlexPeriod: periodType === 'zone',
        flexZone: null,
        arrivalDate: null,
        departureDate: null
      };
      $('body').removeClass('isFlexPeriod');
      this.setDatas(modelDatas);
    }

    if (periodType !== 'zone') {
      this.updateZone($period.data('holiday'));
    }

    this.updateEngineField();
    if (!DEVICE.isMobile) {
      this.$flexField.addClass('opened');
    }
  },
  setDatas(datas) {
    this.temporaryModel.set(datas, {'silent': false});
    dispatcher.trigger('search:updateMainSearchStore', 'isFlexPeriod', datas.isFlexPeriod);
    dispatcher.trigger('search:updateMainSearchStore', 'flexZone', datas.flexZone);
    dispatcher.trigger('search:updateMainSearchStore', 'date', [{key: datas.arrivalDate, value: datas.arrivalDate}]);
    dispatcher.trigger('search:updateMainSearchStore', 'dateend', [{key: datas.departureDate, value: datas.departureDate}]);
  },
  cleanFixDates() {
    dispatcher.trigger('facette:dates:resetDate', false);
    if (DEVICE.isMobile) {
      $('.pika-single.arrival').removeClass('is-hidden');
    }
  },
  cleanFlexPeriod(silent = false) {
    this.temporaryModel.set({'isFlexPeriod': false, 'duration': null, 'flexZone': ''}, {'silent': silent});
    dispatcher.trigger('search:updateMainSearchStore', 'isFlexPeriod', false);
    dispatcher.trigger('search:updateMainSearchStore', 'duration', null);
    dispatcher.trigger('search:updateMainSearchStore', 'flexZone', '');
    $('.js-durationButton').removeClass('u-disabled selected');
    $('.js-selectPeriod').removeClass('disabled active');
    $('body').removeClass('isFlexPeriod');
    this.flexSelection = {month: '', holiday: '', zone: ''};
  },
  updateEngineField() {
    const durationModel = this.temporaryModel.get('duration');
    const duration = durationModel && typeof durationModel !== 'undefined' ? durationModel : '';
    const hasFlexPeriod = this.flexSelection.month !== '' || this.flexSelection.holiday !== '';
    this.periodLabel = duration === 'weekend' ? $('.js-durationButton_weekend .searchForm-durationButton').text() : duration !== '' ? duration + ' ' + GLOBAL_SCRIPTS.WORDINGS_COMMON.nights : '';

    if (hasFlexPeriod || duration !== '') {
      if (hasFlexPeriod) {
        this.periodLabel += (duration !== '' ? ', ' : '') + $('#' + (this.flexSelection.month !== '' ? this.flexSelection.month : this.flexSelection.holiday)).data('label');
      }

      const flexZone = this.temporaryModel.get('flexZone');

      if (flexZone && flexZone !== '') {
        this.periodLabel += ', ' + $('#' + flexZone).data('label');
      }

      this.$flexField.html(`<p>${this.periodLabel}</p>`);
      $('body').addClass('isFlexPeriod');
      $('.calendarBlock').addClass('isFlex');

      if (!DEVICE.isMobile) {
        $('.js-pika-reset').addClass('visible');
      } else {
        this.updateSearchToggler();
      }
    } else {
      $('body').removeClass('isFlexPeriod');
    }
  },
  updateSearchToggler() {
    $('#searchToggler-dates').html(this.periodLabel);
  },
  // -- Update months available
  updateMonths() {
    const durationModel = this.temporaryModel.get('duration');
    const duration = durationModel && typeof durationModel !== 'undefined' ? durationModel.toString() : '';
    const $allMonths = $('.js-flexMonths .js-selectPeriod');
    const allDurations = JSON.parse(SEARCH_SCRIPTS.DURATION_CP);

    $allMonths.removeClass('disabled');
    if (duration !== '') {
      const monthIdx = duration === 'weekend' ? '2' : duration;
      const monthsList = allDurations[monthIdx].months;

      $.each($allMonths, (_idx, item) => {
        const monthId = $(item).data('month').toString();

        if (!monthsList.includes(monthId)) {
          $(item).addClass('disabled');
        }
      });
    } else {
      $.each($allMonths, (key, item) => {
        const monthId = $(item).data('month').toString();

        let isAvailable = false;

        $.each(allDurations, (_idx, elm) => {
          if (elm.months.includes(monthId)) {
            isAvailable = true;
          }
        });

        if (!isAvailable) {
          $(item).addClass('disabled');
        }
      });
    }
  },
  updateZone(holidaysId) {
    const idxSelected = this.holidays.findIndex(holiday => holiday.code === holidaysId);
    const idxHoliday = idxSelected === -1 ? 0 : idxSelected;

    $('.js-flexZoneSlider').remove();
    $('.js-flexZones').append(this.templateZones(this.holidays[idxHoliday].zones));
    this.initSetPeriodEvent();
  },
  render() {
    $(DEVICE.isMobile ? '#mobileCalendar' : '#mainCalendar').append(this.templateMain());
  },
  templateMain() {
    let tpl = `
    <div class="flexPeriod${this.flexSelection.holiday !== '' ? ' isHolidays' : ''}">
      <div class="searchForm-durationContainer js-searchForm-durationContainer"></div>
      <div class="flexPeriod-tab">
        <a class="js-periodFlexType flexMonths">${this.wordings.flex_month_label}</a>
        <a class="js-periodFlexType flexHolidays">${this.wordings.flex_holidays_label}</a>
      </div>
      <div class="flexPeriod-content">
        <div class="flexMonths-content js-flexMonths">
          <div class="flexPeriod-options">`;
    $.each(this.months, (key, item) => {
      const monthIdx = parseInt(item.code) - 1;
      const wrding = SEARCH_SCRIPTS.MONTHS_LIBELLE.split(';')[monthIdx];
      const activeClass = this.flexSelection.month === ('m-' + item.code) ? ' active' : '';
      tpl += `
            <a id="m-${item.code}" class="js-selectPeriod${activeClass}" data-month="${item.code}" data-start="${item.start}" data-end="${item.end}" data-label="${wrding} ${item.year}">
              ${wrding}
              <span>${item.year}</span>
            </a>`;
    });
    tpl += `
          </div>
        </div>
        <div class="flexHolidays-content">
          <div class="flexPeriod-options js-flexHolidays">`;
    let selectedIndexCode = 0;
    $.each(this.holidays, (key, item) => {
      let activeClass = '';
      if (this.flexSelection.holiday === ('h-' + item.code)) {
        activeClass = ' active';
        selectedIndexCode = key;
      }
      const iconCode = item.code === 'PAQUES' ? 'printemps' : item.code.toLowerCase();
      tpl += `
            <a id="h-${item.code}" class="js-selectPeriod${activeClass}" data-holiday="${item.code}" data-start="${item.start}" data-end="${item.end}" data-label="${item.name} ${item.year}">
              <i class="icon icon-${iconCode}"></i>
              ${item.name}
              <span>${item.year}</span>
            </a>`;
    });
    tpl += `
          </div>
          <p>${this.wordings.flex_school_zone}</p>
          <div class="js-flexZones swiper-container flexPeriod-zones">
            ${this.templateZones(this.holidays[selectedIndexCode].zones)}
          </div>
        </div>
      </div>
    </div>
    <div class="u-Visible-mobile flexPeriod-validate">
      <a class="js-flexPeriod-validate">${this.wordings.filter_validate_label}</a>
    </div>`;

    return tpl;
  },
  templateZones(datasZones) {
    let tpl = `
    <div class="swiper js-flexZoneSlider flexPeriod-options">
      <div class="swiper-wrapper">`;
    $.each(datasZones, (_key, item) => {
      const dateStart = new Date(item.start);
      const dateEnd = new Date(item.end);
      const shortMonths = GLOBAL_SCRIPTS.MONTHS_SHORT_LIBELLE.split(';');
      const dateLabel = dateStart.getDate() + ' ' + shortMonths[dateStart.getMonth()] + ' - ' + dateEnd.getDate() + ' ' + shortMonths[dateEnd.getMonth()];
      const activeClass = this.flexSelection.zone === ('z-' + item.id) ? ' active' : '';

      tpl += `
      <a id="z-${item.id}" class="swiper-slide js-selectPeriod${activeClass}${this.flexSelection.holiday === '' ? ' disabled' : ''}" data-start="${item.start}" data-end="${item.end}" data-label="${item.name}">
        <strong>${item.name}</strong>
        <span>${dateLabel}</span>
      </a>`;
    });
    tpl += `</div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div >`;

    return tpl;
  }
});